import React from 'react';
import { Typography, Button, Fade, Grow } from '@material-ui/core';
import * as urlUtils from "../../../../utils/urlUtils";

export default () => {

    const Authorize = () => {
        window.location.href = urlUtils.transferSearchQueryParams(window.location.search, '/auth/login', ['x-frames-allow-from', 'token']);
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <div>
                <Fade in={true} timeout={600}>
                    <Typography variant='h5'>
                    Messaging Bridge - Widget Setup
                    </Typography>
                </Fade>
            </div>

            <div style={{ padding: '50px 0' }}>
                <Grow in={true} timeout={900}>
                    <Typography component='div' className='main-text'>
                        <p>
                        Blix Messaging Bridge allows your team to communicate directly with your website visitors with or without the need for them to disclose their private email addresses. You can add a Widget to your website now and begin handling your customer feedback with ease, providing superior analysis, distribution and response. It’s very simple to add the Blix Messaging Bridge Widget to your website and start getting the feedback you always wanted.
                        </p>
                        {/* <p>
                            Using our technology, once you reply to them, they will receive your email in their real mailboxes increasing the interaction significantly.
                        </p> */}
                    </Typography>
                </Grow>
            </div>

            <Button
                onClick={Authorize}
                variant="contained"
                color='primary'
                style={{
                    flexShrink: 0,
                    width: '50%',
                    borderRadius: 7
                }}
            >
                Sign In
            </Button>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/containers/widget/components/Steps/Step1.js